import React from "react";
import { useSpring, animated } from "react-spring";
import profile from "../static/img/profile-hacker-alpha.png";

export default function AboutMe() {
  const fade_animation = useSpring({
    opacity: 1,
    from: { opacity: 0 },
  });

  return (
    <animated.div id="about" style={fade_animation}>
      <div className="container-sm">
        <div className="row justify-content-around mt-5 mt-lg-0 pt-5 pt-md-2">
          <div className="col-10 col-lg-4">
            <div className="avatar-efect">
              <img
                src={profile}
                className="about-img shadow"
                alt="me"
              />
              <div className="box"></div>
            </div>
          </div>
          <div className="col-11 col-lg-6">
            <div className="mt-5 pt-5 pt-lg-0 mt-lg-0"></div>
            <div className="hr-purple mb-3 mt-5 mt-lg-0 d-none d-md-block"></div>
            <h2 className="text-white mt-2 mt-md-0 text-center text-md-left">
              Soy un Web Developer
            </h2>
           <div className="text-center text-md-left mb-5 mb-md-0">
              <p className="mt-5">
                Hola que tal, soy <strong>Eduardo Talavera</strong> un <strong>Web Developer</strong> al que
                le apasiona transformar el código en soluciones creativas. 
              </p>
              <p>
                Entusiasta de aprender
                nuevas tecnologías y aplicar mis conocimientos en proyectos
                desafiantes.
              </p>
           </div>

            {/* <div className="py-5"></div> */}
{/* 
            <div id="terminal" className="mt-5 d-none d-sm-block">
              <div id="header">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div id="body" className="video-container">
                <video className="d-none d-sm-block" autoPlay loop>
                  <source src={coding} type="video/mp4" />
                </video>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </animated.div>
  );
}
